// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","243":"307c1cf31df043fbcfea","615":"bbd8ee1f57f29565294e","682":"010d3484390bfdcb1778","688":"68ade61144ac6cd25377","852":"f7674fcc58a539abfecd","951":"e112a1540854a300343e"}[chunkId] + ".bundle.js";
};